import { useState } from "react";
import Modal from "./Modal.js";

import wdlogo from "../assets/icons/WD-logo.svg"

const Developer = ({ APPDATA }) => {
   const [modalState, setModalState] = useState(false);

   const styleH2 = { color: "white", fontFamily: "Arial", textDecoration: "none" }

   const checkLink = (str) => {
      let result =
         <>{str}</>;
      if (/^(https?:\/\/)/i.test(str)) { //is website
         result =
            <a href={str} rel="noreferrer" target="_blank">{str}</a>
      } else if (/^\S+@\S+\.\S+$/i.test(str)) { //is email
         result =
            <a href={"mailto:" + str} rel="noreferrer" target="_blank">{str}</a>
      }
      return result
   }


   return (
      <div >
         <span >
            <i>
               Another amazing&nbsp;
               <img src={wdlogo} width="30" alt="WrightsDesk"
                  style={{ cursor: "help" }}
                  title="Show App details"
                  onClick={() => {
                     setModalState(true);
                  }} aria-hidden></img>
               &nbsp;development.
            </i>
         </span >

         <Modal modalState={modalState} >
            <div id="modalchild" onClick={() => setModalState(false)} onBlur={() => setModalState(false)} aria-hidden title="Click or tap anywhere to close">
               Website Developed by:
               <hr />
               <a href="https://www.wrightsdesk.com"
                  rel="noreferrer"
                  target="_blank"
                  title="www.wrightsdesk.com"
               >
                  <h2 style={styleH2}>
                     Wrights
                     <img src={wdlogo} width="30" alt="WrightsDesk"></img>
                     Desk
                  </h2>
               </a>
               <hr />
               <ul> {/* // APPDATA iteration */}
                  {Object.entries(APPDATA).map((data) => {

                     return (
                        <li key={data[0]} className="row col-12">
                           <span className="col-5" width="50%" align="right">
                              {data[0]}:&emsp;
                           </span>
                           <span className="col-7" width="50%" align="left">
                              {typeof (data[1]) === "object"
                                 ?
                                 Object.entries(data[1]).map((e) => {
                                    return (
                                       <span key={e[0]}>
                                          {checkLink(e[0])}:&nbsp;{checkLink(e[1])}<br />
                                       </span>
                                    )
                                 })
                                 : checkLink(data[1])}
                           </span>

                        </li>
                     )

                  })}
               </ul>
               <hr />
               <small><i>Click or tap anywhere to close</i></small>
            </div>
         </Modal>

      </div >
   )
}

export default Developer;